<header class="w-100" nx-header>

  @if (withNavigation && roleCards.length>1) {
    <nx-header-navigation>
      <nx-header-navigation-item>
        <a
          routerLink="/"
          nxHeaderLink
          [routerLinkActiveOptions]="{exact: true}"
          routerLinkActive="is-active"
          [skipLocationChange]="true"
          nxTooltip="{{'general.home' | caption}}"
          >
          @if (!mobil) {
            {{'general.home' | caption}}
          }
          @if (mobil) {
            <button nxPlainButton="">
              <nx-icon name="home" [attr.aria-label]="'general.home' | caption"></nx-icon>
            </button>
          }
        </a>
      </nx-header-navigation-item>
      @for (card of roleCards; track card) {
        <nx-header-navigation-item>
          <a [routerLink]="card.startUri"
            nxHeaderLink
            [routerLinkActiveOptions]="{exact: true}"
            routerLinkActive="is-active"
            nxTooltip="{{card.title | caption}}"
            >
            @if (!mobil) {
              {{card.title | caption}}
            }
            @if (mobil) {
              <button nxPlainButton="">
                <nx-icon name="{{card.iconName}}" [attr.aria-label]="card.title | caption"></nx-icon>
              </button>
            }
          </a>
        </nx-header-navigation-item>
      }
    </nx-header-navigation>
  }
  <nx-header-actions>
    <!--    <button nxPlainButton="">-->
    <!--      <nx-icon name="search" aria-label="Open Search Bar"></nx-icon>-->
  <!--    </button>-->


  <nx-link size="large">
    <a href="javascript:void(0)" class="nx-margin-left-s user-icon"
      scrollStrategy="close"
      [nxContextMenuTriggerFor]="menu">
      <nx-icon name="user-o" size="s" aria-label="Logged in"></nx-icon>
    </a>
  </nx-link>
  <nx-context-menu #menu="nxContextMenu">
    @if (authUser) {
      <button disabled nxContextMenuItem>
        <nx-icon aria-hidden="true" name="user-o" class="nx-margin-right-s"></nx-icon>
        {{authUser.lastName}} {{authUser.firstName}} <br>{{authUser.email}}</button>
        <button nxContextMenuItem type="button" (click)="logout()">{{'general.logout' | caption}}</button>
      }

    </nx-context-menu>
  </nx-header-actions>
</header>
